<template>
	<ol class="wizard-list connected-icons collapse-content">
		<li>
			<div class="icon flex-center br-5" style="background:#EEDAFE;height:48px;">
				<svg class="block" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M13.5 15.7495L17.25 19.4995L20.9999 15.7501" stroke="#8D05FB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M17.25 10.4993V19.4993" stroke="#8D05FB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M4.5 11.9995H11.2499" stroke="#8D05FB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M4.5 5.99951H17.2499" stroke="#8D05FB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M4.5 17.9995H9.75" stroke="#8D05FB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
			<p>Add your preferred job candidates to the Instant Offer list.</p>
		</li>
		<li>
			<icon-square-paper-plane />
			<p>
				Once you finalize your instant offer list, ShootWith.Me will contact all candidates with a job offer!
			</p>
		</li>
		<li>
			<icon-square-check />
			<p>
				The first candidate that accepts will be booked for the job. You'll be able to coordinate details directly with your shooter.
			</p>
		</li>
		<li>
			<icon-square-cancel />
			<p>
				If all candidates decline the job, or if the Time Window for Response expires, you'll be notified by ShootWith.Me to add more candidates to your offer list and resend a new instant offer.
			</p>
		</li>
	</ol>
</template>

<script>
export default {
  name: 'InstantOfferExplainer',
}
</script>